import { cepFragment } from './cep.fragments';

export const tacticFragment = `
  _id
  tacticId
  formattedTacticId
  title
  channel
  cep {
    ${cepFragment}
  }
  dateStart
  dateEnd
  description
  dropMaterial {
    id
    name
  }
  executingTeam
  mandatory
  previousTactic{
    _id
    title
  }
  parentTactic{
    _id
    title
  }
  assetName
  callToAction
  keyMessage {
    id
    name
  }
  approvedDocumentId
  status
  eventId
  actionOrder
  isKeyPerformanceIndicator
  destinationUrl
  veevaSyncStatus
  version
  IVADocumentId
  comment
  updated
`;
